import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Team, TeamSalesOrderPhase } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0250. チーム受注フェーズ一覧
 * [GET] /workspaces/:identifier/teams/:team_id/team_sales_order_phases
 */
type Props = {
  identifier: string;
  team_id: number;
  no_cache?: boolean;
};
const teamSalesOrderPhases = (props: Props): Promise<TeamSalesOrderPhase[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/team_sales_order_phases`, {
    params: props,
  });
};

export const useTeamSalesOrderPhases = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'team_sales_order_phases'],
    queryFn: () => teamSalesOrderPhases(props),
  });
};

export const useTeamSalesOrderPhasesNoCache = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'team_sales_order_phases'],
    queryFn: () => teamSalesOrderPhases(props),
    staleTime: props.no_cache ? 10 : Number(process.env.REACT_APP_API_STALE_TIME),
  });
};

export const useInvalidateTeamSalesOrderPhases = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'team_sales_order_phases'],
    });
  };

  return { invalidate };
};
